import { useAppSelector } from "app/store";

export const useGuestPermissions = () => {
  const teamName = useAppSelector((state) => state.audits.headerSelectedTeam);
  const isGuest = teamName === "guest";

  return {
    isGuest,
    teamName,
  };
};
